import FinishExecution from '@components/execution-process/execution-tasks/FinishExecution';
import SectionExecutionComponent from '@components/execution-process/SectionExecutionComponent';
import IProcessValue, { SectionValue } from '@components/FormFlow/Interfaces/IProcessValue';
import ISection from '@components/FormFlow/Interfaces/ISection';
import ISectionCondition, { ISectionConditionRole, OperatorType } from '@components/FormFlow/Interfaces/ISectionCondition';
import PageWithoutTitle from '@components/PageWithoutTitle';
import { safePropertieRetrieve } from '@helpers/validation/ObjectValidator';
import { BaseProcess } from '@interfaces/Process';
import GraphQLTicketService from '@services/graphQL/graphQLTicket';
import GraphQLSchedulingService from '@services/graphQLSchedulingService';
import ProcessValueService from '@services/ProcessValueService';
import TicketService from '@services/TicketEvent';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import { StatusProcess } from '@src/helpers/Enums';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button } from 'antd';
import React from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

import { LocalStorageKeys } from './App';
import AppContext from '@services/Context';


export interface IExecutionProcessProps {
  match: any;
  process?: any;
  updateNotifyContent: Function;
}

interface IExecutionProcessState {
  ticketId: string;
  eventId: string;
  loading: boolean;
  process?: BaseProcess;
  processValue?: IProcessValue;
  currentSection?: ISection;
  currentSectionValue?: SectionValue;
  sectionsValues: SectionValue[];
  currentSectionRegister?: SectionValue;
  firstSectionId?: string;
  sectionsFlowStack: string[],
  getSectionValues: Function;
  gotoStacks: GoToVisited[];
  ticketData: any;
  redirect: boolean;
  sending: boolean;
  curOffset: any;
  label: string;
  totalScore: number;
  totalScoreArr: number[];
  hasFinished: boolean;
  tags: any;
  gotoParentId:any;
  gotoParentIndex:any;
  nextClickError: boolean;
}

export interface GoToVisited {
  goToId: string;
  sectionId: string;
}

const formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor();
export default class ExecutionProcess extends React.Component<IExecutionProcessProps, IExecutionProcessState> {
  private idUnit: string = ''
  private _ticketService = new TicketService();
  private _processValueService: ProcessValueService;
  private _GraphQLTicketService: any = new GraphQLTicketService();
  private _GraphQLSchedulingService: any = new GraphQLSchedulingService();
  private currentPillar: any;

  constructor(props: IExecutionProcessProps) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
      loading: true,
      sectionsFlowStack: [],
      firstSectionId: undefined,
      getSectionValues: () => { },
      gotoStacks: [],
      sectionsValues: [],
      eventId: ``,
      ticketId: ``,
      redirect: false,
      sending: false,
      curOffset: undefined,
      label: '',
      ticketData: [],
      totalScore: 0,
      totalScoreArr: [],
      hasFinished: false,
      tags: safePropertieRetrieve(this.props, 'location.state.tags') || null,
      gotoParentId: [],
      gotoParentIndex: [],
      nextClickError: false
    }

    this.setSectionValuesReceiver = this.setSectionValuesReceiver.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.onGotoDeleteData = this.onGotoDeleteData.bind(this);
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    this._processValueService = new ProcessValueService(this.currentPillar);
  }

  componentDidMount = async () => {
    window.addEventListener('beforeunload', this.changeStatusOnClose, false);
    const newWorkflow = safePropertieRetrieve(this.props, 'location.state.newWorkflow');
    if (newWorkflow) {
      const process = safePropertieRetrieve(this.props, 'location.state.process')
      this.setInitialProcess(process)
      await this._GraphQLSchedulingService.editSchedule(process.schedulerId, { status: 2 })
    }
    else {
      const { match } = this.props;
      await this.loadTicketData(match.params.ticketId);
      await this.loadProcess(match.params.eventId);
    }

  }


  changeStatusOnClose = async () => {
    if (!this.state.hasFinished) {
      const process = safePropertieRetrieve(this.props, 'location.state.process')
      await this._GraphQLSchedulingService.editSchedule(process.schedulerId, { status: 1 })
    }
  }

  componentWillUnmount() {
    this.unmountData()
  }

  unmountData = async () => {
    window.removeEventListener('beforeunload', this.changeStatusOnClose, false);
    this.changeStatusOnClose()
  }

  setInitialProcess = async (process: any) => {

    const newSectionValue = new SectionValue(
      process.sections[0]
    );
    await this.setState({
      process,
      processValue: new IProcessValue(
        process.id,
        process.version,
        process.pillar,
        this.idUnit
      ),
      currentSectionValue: newSectionValue,
      sectionsValues: [newSectionValue],
      currentSection: process.sections[0],
      firstSectionId: process.sections[0].id,
    })

    this.setState({ loading: false })
  }

  async loadTicketData(ticketId: string) {
    const data: any = await this._ticketService.pagingMeProcess({ limit: 100, status: StatusProcess.PENDENT, unit: this.idUnit });
    let newAlertsData: any[] = [];
    let events: any = []
    for (let ticket of data.items) {
      let event = {
        id: ticket.id,
        ticketId: ticket.ticketId,
        eventId: ticket.workflowEvent.eventId,
        processId: ticket.workflowEvent.id,
        label: ticket.label
      }
      events.push(event)
      newAlertsData = newAlertsData.concat(events);
    }
    const ticketData = newAlertsData.find((e: any) => e.ticketId === ticketId);

    await this.setState({ ticketId, ticketData });
  }

  setSectionValuesReceiver(senderFromSection: Function) {
    this.setState({ getSectionValues: senderFromSection });
  }

  //#region  GET INITIAL PROCESS
  async loadProcess(eventId: string) {
    const { ticketData } = this.state;

    try {
      const process: BaseProcess = await formflowService.getById(ticketData.eventId, this.idUnit);
      if (!process || !process.id) {
        return NotificationComponent.Notify('error', I18n.l("notify.ticket.errors.processNotExist"), I18n.l("notify.ticket.errors.messageProcessError"));
      }
      const newSectionValue = new SectionValue(
        process.sections[0]
      );
      await this.setState({
        process: process,
        processValue: new IProcessValue(
          process.id,
          process.version,
          process.pillar,
          this.idUnit
        ),
        eventId,
        currentSectionValue: newSectionValue,
        sectionsValues: [newSectionValue],
        currentSection: process.sections[0],
        firstSectionId: process.sections[0].id,
      })
    }
    catch (e) {
      console.log("formflow error", e);
    }
    this.setState({
      loading: false,
    });
  }
  //#endregion
  onClickNext = async () => {
    
    const sectionRegister = await this.state.getSectionValues(true);
    if (sectionRegister.validation) {
      
      const { currentSection, process, currentSectionValue, totalScoreArr, gotoStacks, gotoParentId,gotoParentIndex } = this.state;
      let newGotoParentId = [...this.state.gotoParentId]
      let newGotoParentIndex = [...this.state.gotoParentIndex]
      totalScoreArr.push(sectionRegister.score);
      await this.setState({
        totalScore: totalScoreArr.reduce((a: any, b: any) => a + b),
        totalScoreArr: totalScoreArr
      });
      let nextSectionId = currentSection ? currentSection.next : ''
      this.saveSectionRegister(sectionRegister.values);
      if (currentSection && currentSection.conditions && currentSectionValue) {
        const cond = currentSection.conditions.find(e => this.validateConditions(currentSectionValue, e))

        if (cond) {
          nextSectionId = cond.sectionId;
        }
      }

      if (!nextSectionId && gotoStacks.length) {
        const gotoItem = gotoStacks.pop()
        nextSectionId = gotoItem ? gotoItem.sectionId : ''
      }
      const nextSection = process.sections.find(e => e.id === nextSectionId);
      //adds section id to sections flow, so we can back back to sessions later by this ids
      let newFlowStackValues = [...this.state.sectionsFlowStack];
      if (currentSection && currentSection.grouped === undefined) {
        newFlowStackValues.push(currentSection.id);
      }else{
        nextSectionId === newFlowStackValues[newFlowStackValues.length-1] ? newFlowStackValues.pop() : null
      }
      let newCurrentSectionValue;
      if (nextSection) {        
        // this.loadCurrentSectionValues(nextSection);
        // creating or updating current section value to change values after
        const { sectionsValues } = this.state;
        if (sectionsValues) {
          const sectionValue = await sectionsValues.find(sec => sec.sectionId === nextSection.id);

          if (sectionValue) {
            newCurrentSectionValue = sectionValue;
          }
        }
        if (!newCurrentSectionValue) {
          newCurrentSectionValue = new SectionValue(
            nextSection as ISection
          );
          await this.setState({ sectionsValues: [...sectionsValues, newCurrentSectionValue] });
        }
      }
      let CurrentGoto : any;
      if(currentSection!.grouped && gotoParentId.length > 0 && gotoParentIndex.length > 0 && newCurrentSectionValue){
        newCurrentSectionValue.components = newCurrentSectionValue.components.map(c => {
          if (c.id === gotoParentId[gotoParentId.length - 1]){
            if(!c.input){
              c.input = []
              c.value = []
            }   
            c.input[gotoParentIndex[gotoParentIndex.length - 1]] = currentSectionValue.id
            c.value[gotoParentIndex[gotoParentIndex.length - 1]] = currentSectionValue.id
            CurrentGoto = [c];
            newGotoParentId.pop()
            newGotoParentIndex.pop()
          }
          return c
        })
      }else{
        await this.updateSectionRegisterNext(newCurrentSectionValue ? newCurrentSectionValue.id : undefined);
      }
      this.setState({
        currentSection: nextSection ? nextSection : undefined,
        currentSectionValue: newCurrentSectionValue || this.state.currentSectionValue,
        sectionsFlowStack: newFlowStackValues,
        gotoParentId: newGotoParentId,
        gotoParentIndex: newGotoParentIndex,
        nextClickError:false,
      },() => {
        CurrentGoto ? this.saveSectionRegister(CurrentGoto) : null;
        this.loadCurrentSectionValues(nextSection);
      });
    } else {;
      this.setState({nextClickError:true})
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('process.execution.fieldsNotFilled'));
    }
  }

  onClickPrevious = async () => {
    const { process, sectionsValues, sectionsFlowStack, processValue, currentSection, totalScoreArr } = this.state;
    //save section values on register
    const sectionValues = await this.state.getSectionValues(false);
    if(currentSection.grouped === undefined)
    this.saveSectionRegister(sectionValues.values);

    //loads data of the section that we are going to
    const lastId = sectionsFlowStack.pop();

    const nextSection = process.sections.find(e => e.id === lastId);
    await this.loadCurrentSectionValues(nextSection);

    //removes this actual section from the sections values
    const newSectionsValues = [...sectionsValues];
    const nextSectionValue = sectionsValues.find(sec => sec.sectionId === nextSection.id);
    const newProcessValue = { ...processValue };
    if(currentSection.grouped === undefined){
      newSectionsValues.pop();
      //loads the section value of the section that i am going to
      //remove the values of this actual section from the process value that will be saved eventually
      if (newProcessValue) {
        if (newProcessValue.sections) {
          const sectionIndex = newProcessValue.sections.findIndex((s: any) => currentSection.id === s.sectionId);
          if (sectionIndex != -1) {
            newProcessValue.sections.splice(sectionIndex, 1);
          }
        }
      }
      totalScoreArr.pop(); //remove last score
    }
    await this.setState({
      processValue: newProcessValue as IProcessValue,
      currentSection: nextSection,
      currentSectionValue: nextSectionValue,
      sectionsValues: newSectionsValues,
      totalScore: totalScoreArr.reduce((a: any, b: any) => a + b, 0),
      totalScoreArr: totalScoreArr
    });
  }

  async saveSectionRegister(componentsValues: any, nextSectionId?: string) {
    const { currentSectionValue, processValue } = this.state;
    //saving components values to section value
    const newSectionValue: any = { ...currentSectionValue };
    newSectionValue.next = nextSectionId ? nextSectionId : null;
    if (newSectionValue && newSectionValue.components) {
      for (const comp of componentsValues) {
        const compIndex = newSectionValue.components.findIndex((c: any) => c.id === comp.id);
        if (compIndex != -1) {
          newSectionValue.components[compIndex].input = comp.value != undefined ? comp.value : [];
          newSectionValue.components[compIndex].value = newSectionValue.components[compIndex].input
          newSectionValue.components[compIndex].validation = comp.validation;
          if (comp.type === 11) {
            newSectionValue.components[compIndex].input = this.state.totalScore
            const scoreValue = comp.results.find((e: any) => { return (this.state.totalScore >= e.min && this.state.totalScore <= e.max) })
            newSectionValue.components[compIndex].value = scoreValue.label
          }
          if (comp.file) {
            newSectionValue.components[compIndex].file = comp.file != undefined ? comp.file : [];
          }
        }
      }
    }
    // saving section to process
    const newProcessValue: any = { ...processValue };
    // const sectionEditIndex = newProcessValue.sections.findIndex((s: any) => s.id === newSectionValue.id);
    const sectionEditIndex = newProcessValue.sections.findIndex((s: any) => s.sectionId === newSectionValue.sectionId);
    if (sectionEditIndex == -1) {
      newProcessValue.sections.push(newSectionValue);
    } else {
      newProcessValue.sections[sectionEditIndex] = newSectionValue;
    }    
    await this.setState({
      currentSectionValue: newSectionValue,
      processValue: newProcessValue,
    });
  }

  async updateSectionRegisterNext(nextSectionId?: string) {
    const { currentSectionValue, processValue } = this.state;    
    const newSectionValue: any = { ...currentSectionValue };
    newSectionValue.next = nextSectionId ? nextSectionId : null;

    // saving section to process
    const newProcessValue: any = { ...processValue };
    const sectionEditIndex = newProcessValue.sections.findIndex((s: any) => s.id === newSectionValue.id);
    if (sectionEditIndex != -1) {      
      newProcessValue.sections[sectionEditIndex] = newSectionValue;
    }
    
    this.setState({
      currentSectionValue: newSectionValue,
      processValue: newProcessValue,
    });
  }

  // call before update current section, so when it opens, components default values will be filled
  async loadCurrentSectionValues(section: any) {
    const { processValue } = this.state;
    const newCurrentSectionRegister = section ? processValue.sections.find(s => s.sectionId === section.id) : undefined;
    if (newCurrentSectionRegister) {
      await this.setState({
        currentSectionRegister: newCurrentSectionRegister,
      })
    }
  }
  async onGotoDeleteData(sectionId: string, sectionCompId: string, index: number, compId: string) {
    const { currentSectionValue } = this.state;
    const sectionRegister = await this.state.getSectionValues(true);
    let newComponents = sectionRegister.values.map((v: any) => {
      let newValue = v
      if (v.id === compId) {      
        // newValue.input[index] = null
        newValue.value[index] = null
        return newValue
      }
      return v
    })
    let newCurrentSectionValue = Object.assign({}, currentSectionValue, { components: newComponents })
    this.setState({
      currentSectionValue: newCurrentSectionValue
    })
  }
  onClickGoto = async (index: number, componentId: string, repeat : boolean) => {
    const { sectionsFlowStack, currentSection, process, processValue, gotoStacks } = this.state
    const comp = (currentSection as any).components.find((e: any) => e.id == componentId);
    const { sectionId, id: fromGoToId } = comp.options[repeat ? 0 : index] // index 0 fixed to repeat!
    // console.log('parans',index,componentId,repeat,sectionId,fromGoToId);
    // console.log('comp',comp);
    const sectionRegister = await this.state.getSectionValues(true);
    const compVal = sectionRegister.values.find((e: any) => e.id == componentId);
    if(repeat){
      // index = comp.options.findIndex((e: any) => e.sectionId == sectionId)
    }else{
      // index = compVal.value ? compVal.value.length : 0
    }
    const val = compVal.value ? [...compVal.value] : new Array(comp.options.length).fill(null);
    // console.log('val',val);
    
    const nextSection = process ? process.sections.find(e => e.id === sectionId) : undefined;
    const sectionProcessValue = processValue ? processValue.sections.filter(v => v.sectionId === sectionId) : undefined;
    let newCurrentSectionValue
    // console.log('sectionProcessValue',sectionProcessValue);
    
    let newGotoParentId = [...this.state.gotoParentId,componentId]
    let newGotoParentIndex = [...this.state.gotoParentIndex,index]
    if (sectionProcessValue && sectionProcessValue[0] && val[index] !== null) {
      newCurrentSectionValue = sectionProcessValue[0]
      this.loadCurrentSectionValues(nextSection);
    } else {
      newCurrentSectionValue = new SectionValue(
        nextSection as ISection
      );
    }
    
    await this.saveSectionRegister(sectionRegister.values);
    // val[index] = newCurrentSectionValue.id;
    compVal.value = val;
    const item = {
      goToId: fromGoToId,
      sectionId: currentSection ? currentSection.id : ''
    };
    gotoStacks.push(item)
    sectionsFlowStack.push(item.sectionId);
    await this.setState({
      sectionsFlowStack: sectionsFlowStack,
      currentSection: nextSection,
      gotoStacks: gotoStacks,
      currentSectionValue: newCurrentSectionValue,
      gotoParentId: newGotoParentId,
      gotoParentIndex: newGotoParentIndex
    })
  }

  validateConditions(currentSectionValue: SectionValue, condition: ISectionCondition): boolean {
    return condition.rules.some(e => this.validateRule(currentSectionValue, e));
  }

  validateRule(currentSectionValue: SectionValue, role: ISectionConditionRole): boolean {
    const compX = currentSectionValue.components.find(e => e.id === role.xItem.id)
    if (!compX) {
      return false;
    }
    let valueY = role.value;
    if (valueY === undefined && role.yItem) {
      const compY = currentSectionValue.components.find(e => role.yItem ? e.id === role.yItem.id : false)
      if (!compY) {
        return false;
      }
      valueY = compY.input;
    }
    let newComp = Array.isArray(compX.input) ? compX.input[0] : compX.input;
    switch (role.operator) {
      case OperatorType.Contains: {
        return newComp.indexOf(valueY) !== -1;
      }
      case OperatorType.Equals: {
        return valueY === newComp;
      }

      case OperatorType.GreaterOrEqualsThan: {
        return newComp >= valueY;
      }
      case OperatorType.GreaterThan:
        {
          return newComp > valueY;
        }
      case OperatorType.LessOrEqualsThan:
        {
          return newComp <= valueY;
        }

      case OperatorType.LessThan:
        {
          return newComp < valueY;
        }

      case OperatorType.NotContains: {
        return newComp.indexOf(valueY) === -1;
      }
      case OperatorType.NotEquals:
        {
          return newComp !== valueY;
        }
      default:
        return false;
    }
  }

  async onFinish() {
    const { processValue, ticketData } = this.state;
    this.setState({ sending: true });
    let newProcessValue = processValue || { sections: [] };
    newProcessValue.sections.map((s: any) => {
      if (s.next === null) delete s.next
    })

    try {
      const data: any = await this._processValueService.processExec(this.idUnit, ticketData.id, newProcessValue as IProcessValue);

      const newWorkflow = safePropertieRetrieve(this.props, 'location.state.newWorkflow');
      const userId = localStorage.getItem('userId')
      const userName = localStorage.getItem('username')
      if (newWorkflow) {
        const { id, schedulerId } = safePropertieRetrieve(this.props, 'location.state.process');
        data.owner = {
          name: userName,
          id: userId
        }
        await this._GraphQLTicketService.createTicket({ scheduleId: schedulerId, processValue: data, processId: id })
        await this._GraphQLSchedulingService.editSchedule(schedulerId, { status: 3 })
        this.setState({ hasFinished: true })
      }

      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("process.execution.executionFinishNotification"));
      this.setState({ redirect: true });
      this.props.updateNotifyContent(true);
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("process.execution.errorSending"), e);
      this.setState({ sending: false })
    }
  }

  renderNoTicket() {
    return (
      <React.Fragment>
        <h2>{I18n.l('process.execution.noTicket')}</h2>
      </React.Fragment>
    );
  }

  onGoBackClicked() {
    this.props.history.goBack();
  }

  formatHTML(label: any) {
    return { __html: label };
  }


  render() {
    const {
      currentSection,
      firstSectionId,
      currentSectionRegister,
      processValue,
      process,
      loading,
      sectionsFlowStack,
      totalScore,
      nextClickError
    } = this.state

    if (loading) {
      return (
        <PageWithoutTitle >
          <h3>{I18n.l('common.loadingData')}</h3>
        </PageWithoutTitle>
      );
    }
    return (
      <AppContext.Consumer>
        {({ updateNotification }) => (
          <PageWithoutTitle >
            {process &&
              <h1 style={{ margin: 0 }} className='process-name-style'>{process.name}</h1>
            }
            {process &&
              <div style={{ fontSize: '1.5em', marginBottom: '20px' }} dangerouslySetInnerHTML={this.formatHTML(this.state.ticketData.label)}></div>

            }
            <Wrapper>
              {this.state.redirect &&
                <Redirect
                  push
                  to={Routes.ehssHistory}
                />
              }
              {currentSection &&
                <React.Fragment>
                  {this.currentPillar !== "LI" && <Link target="_blank" to={`${Routes.ticketDetailsEhss}/${this.props.match.params.ticketId}`}>{I18n.l('process.seeTicket')}</Link>}
                  {this.currentPillar === "LI" && this.state.tags && <div>
                    {Object.keys(this.state.tags).map((r, index) => <span key={index}>
                      <strong>{I18n.l(`tags.${r}`)}:</strong> {this.state.tags[r]}{(index + 1) < Object.keys(this.state.tags).length ? ', ' : ''}
                    </span>)}
                  </div>}
                  <div className='card-section'>

                    <SectionExecutionComponent
                      id={currentSection.id}
                      sectionRegister={currentSectionRegister}
                      components={currentSection.components}
                      onClickGoto={this.onClickGoto}
                      onGotoDeleteData={this.onGotoDeleteData}
                      setRegisterSender={this.setSectionValuesReceiver}
                      totalScore={totalScore}
                      nextClickError={nextClickError}
                    />
                  </div>
                </React.Fragment>
              }
              <div className={'flow-buttons-container'}>
                {sectionsFlowStack.length > 0 && currentSection && currentSection.id !== firstSectionId && (
                  <Button className={'flow-button last-section-btn'} onClick={this.onClickPrevious}>{I18n.l('common.previous')}</Button>
                )}
                {currentSection && (
                  <Button className={'flow-button next-section-btn'} onClick={this.onClickNext} type='primary'>{I18n.l(currentSection.next ? 'common.next' : 'common.finish')}</Button>
                )}
              </div>
              {(currentSection === undefined && process != undefined) &&
                <FinishExecution
                  start={processValue ? processValue.startAt : undefined}
                  finish={Date.now().toString()}
                  sending={this.state.sending}
                  onFinishClick={this.onFinish}
                  onUpdateNotification={updateNotification}
                />
              }
              {(currentSection === undefined && process == undefined) &&
                <React.Fragment>
                  <div className='card-section'>
                    <div className='no-ticket-container'>
                      {this.renderNoTicket()}
                    </div>
                  </div>
                  <Button type='primary' style={{ textTransform: 'uppercase', fontWeight: 'bold' }} onClick={() => this.onGoBackClicked()}>
                    {I18n.l('common.back')}
                  </Button>
                </React.Fragment>
              }
            </Wrapper>
          </PageWithoutTitle >
        )}
      </AppContext.Consumer>
    );
  }
}

const Wrapper = styled.div`
    width: 100%;
    .card-section{
      width: 100%;
      padding-top: 25px;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 25px;
      border-radius: 5px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      min-height: 150px;
    }
    .no-ticket-container{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 150px;
    }
    .flow-buttons-container{
      display: flex;      
    }
    .flow-button {
      text-transform: uppercase;
      min-width: 115px;
      font-weight: bold;
    }
    .last-section-btn {
      justify-self: flex-start;
    }
    .next-section-btn {
      justify-self: flex-end;
      margin-left: auto;
      margin-right: 0;
    }

`;
